import { render, staticRenderFns } from "./LoginInfo.vue?vue&type=template&id=06e5af6e&scoped=true&"
import script from "./LoginInfo.vue?vue&type=script&lang=js&"
export * from "./LoginInfo.vue?vue&type=script&lang=js&"
import style0 from "./LoginInfo.vue?vue&type=style&index=0&id=06e5af6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5af6e",
  null
  
)

export default component.exports